import getProjectCorrespondenceEntry from "./getProjectCorrespondenceEntry";
import createProjectCorrespondenceEntry from "./createProjectCorrespondenceEntry";
import updateProjectCorrespondenceEntry from "./updateProjectCorrespondenceEntry";
import deleteProjectCorrespondenceEntry from "./deleteProjectCorrespondenceEntry";

import getProjectCorrespondenceEntries from "./getProjectCorrespondenceEntries";

export { getProjectCorrespondenceEntry, createProjectCorrespondenceEntry, updateProjectCorrespondenceEntry, deleteProjectCorrespondenceEntry, getProjectCorrespondenceEntries };

export default { getProjectCorrespondenceEntry, createProjectCorrespondenceEntry, updateProjectCorrespondenceEntry, deleteProjectCorrespondenceEntry, getProjectCorrespondenceEntries };